import React from 'react';
import { Link } from 'react-router-dom';

export interface PageCrumb {
  label: string;
  /** Where the crumb goes; the last crumb (the page you are on) has none. */
  to?: string;
}

interface PageBarProps {
  crumbs: readonly PageCrumb[];
  /** The actions of the page (Filters, the Archived switch, New ..., Save), on the same row as the crumbs. */
  children?: React.ReactNode;
}

/**
 * The breadcrumb bar of a screen that the global Header does not draw a bar for: crumbs on the left, actions on the right of the
 * SAME row, in the Header's own classes so it looks the same. Use it until the screen's bar is wired into Header.tsx.
 */
const PageBar: React.FC<PageBarProps> = ({ crumbs, children }) => (
  <div className="global-breadcrumb-bar page-bar">
    <div className="global-breadcrumb-left">
      <nav className="global-breadcrumb-trail" aria-label="Breadcrumb">
        {crumbs.map((crumb, index) => {
          const last = index === crumbs.length - 1;
          return (
            <React.Fragment key={`${crumb.label}-${index}`}>
              {index > 0 && <span className="global-breadcrumb-separator" aria-hidden="true">/</span>}
              {last || !crumb.to ? (
                <span className="global-breadcrumb-current" aria-current={last ? 'page' : undefined}>{crumb.label}</span>
              ) : (
                <Link className="global-breadcrumb-link" to={crumb.to}>{crumb.label}</Link>
              )}
            </React.Fragment>
          );
        })}
      </nav>
    </div>
    {children && <div className="global-breadcrumb-actions">{children}</div>}
  </div>
);

export default PageBar;
